import { render, staticRenderFns } from "./IcoDocsCompleted.vue?vue&type=template&id=ed71d378"
import script from "./IcoDocsCompleted.vue?vue&type=script&lang=js"
export * from "./IcoDocsCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports